import { mapActions, mapGetters } from 'vuex';
import tabs from '@/components/generics/tabs/tabs.vue';
import addFundsCard from '@/components/wallet/add-funds-card/add-funds-card.vue';
import addFundsCash from '@/components/wallet/add-funds-cash/add-funds-cash.vue';
import addFundsCoinbase from '@/components/wallet/add-funds-coinbase/add-funds-coinbase.vue';
import addFundsBankTransfer from '@/components/wallet/add-funds-bank-transfer/add-funds-bank-transfer.vue';
import pendingRequests from '@/components/wallet/pending-requests/pending-requests-list-deposit/pending-requests-list-deposit.vue';
import loaderMixin from '@/mixins/loader';

export const TAB_INDEX_CREDIT = 0;
export const TAB_INDEX_PAY_NEAR_ME = 1;
export const TAB_INDEX_COINBASE = 2;
export const TAB_INDEX_ONLINE_BANKING = 3;
export const TAB_INDEX_PENDING = 4;

const GTM_PAGE_NAME = 'deposit';

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    addFundsCard,
    addFundsCash,
    addFundsCoinbase,
    addFundsBankTransfer,
    pendingRequests,
    tabs,
  },
  data() {
    return {
      showTabs: false,
      tabIndexOrder: [],
      isCashAvailable: false,
      isCryptoAvailable: false,
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      cryptoDescription: '',
      activeTab: null,
      cardDepositAttempt: 1,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    showBankingTab() {
      return this.activeTab === TAB_INDEX_ONLINE_BANKING;
    },
    showCreditCardTab() {
      return this.activeTab === TAB_INDEX_CREDIT;
    },
    showCashTab() {
      return this.activeTab === TAB_INDEX_PAY_NEAR_ME;
    },
    showCoinBaseTab() {
      return this.activeTab === TAB_INDEX_COINBASE;
    },
    showPendingTab() {
      return this.activeTab === TAB_INDEX_PENDING;
    },
    tabs() {
      const results = [];
      this.tabIndexOrder.forEach((v) => {
        if (this.isOnlineBankingAvailable && v === TAB_INDEX_ONLINE_BANKING) {
          results.push({
            name: TAB_INDEX_ONLINE_BANKING,
            title: this.isLayoutMobile ? 'Online Banking' : 'Online Banking',
          });
        }
        if (this.isCreditCardAvailable && v === TAB_INDEX_CREDIT) {
          results.push({
            name: TAB_INDEX_CREDIT,
            title: this.isLayoutMobile ? 'Credit Card' : 'Credit Card',
          });
        }
        if (this.isCashAvailable && v === TAB_INDEX_PAY_NEAR_ME) {
          results.push({
            name: TAB_INDEX_PAY_NEAR_ME,
            title: 'Cash',
          });
        }
        if (this.isCryptoAvailable && v === TAB_INDEX_COINBASE) {
          results.push({
            name: TAB_INDEX_COINBASE,
            title: this.cryptoDesctiption,
          });
        }
      });
      results.push({
        name: TAB_INDEX_PENDING,
        title: 'Pending',
      });
      return results;
    },
  },
  methods: {
    ...mapActions('wallet', ['getDepositMethods']),
    tabChange(name) {
      this.activeTab = name;

      if (this.$route && this.$route.path) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage: `${this.$route.path}/${GTM_PAGE_NAME}/${name}`,
          virtualPageTitle: `${this.$route.name} - ${GTM_PAGE_NAME} - ${name}`,
        });
      }
    },
    onAddFundsCardSuccess() {
      this.cardDepositAttempt += 1;
    },
  },
  created() {
    this.loaderAdd(document.body);
    this.getDepositMethods()
      .then((data) => {
        this.showTabs = true;
        this.tabIndexOrder = data.tabIndexOrder;
        this.isCashAvailable = data.isCashAvailable;
        this.isCryptoAvailable = data.isCryptoAvailable;
        this.isCreditCardAvailable = data.isCreditCardAvailable;
        this.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
        this.cryptoDesctiption = data.cryptoDescription || 'USDC';
        this.loaderRemove(document.body);
      })
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/deposit/deposit.js